import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from "recharts";
import Icon from "components/AppIcon";

const COLORS = ["#00D9FF", "#FFB800", "#10B981", "#EF4444", "#8B5CF6", "#F59E0B"];

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-border p-3 text-xs" style={{ background: "var(--color-card)" }}>
      <div className="font-caption text-muted-foreground">{payload?.[0]?.name}</div>
      <div className="font-data font-semibold text-foreground">{payload?.[0]?.value?.toFixed(1)}%</div>
    </div>
  );
};

const SectorAllocation = ({ sectors }) => (
  <div className="rounded-xl border border-border p-4 md:p-6 h-full" style={{ background: "var(--color-card)" }}>
    <div className="flex items-center gap-2 mb-4">
      <Icon name="PieChart" size={18} color="var(--color-accent)" />
      <h3 className="font-heading text-base font-semibold text-foreground">Sector Allocation</h3>
    </div>
    <div className="w-full h-44 md:h-52">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie data={sectors} cx="50%" cy="50%" innerRadius="55%" outerRadius="80%" dataKey="value" paddingAngle={3}>
            {sectors?.map((_, i) => <Cell key={i} fill={COLORS?.[i % COLORS?.length]} />)}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ fontFamily: "Fira Code", fontSize: 10, color: "var(--color-muted-foreground)" }} iconSize={8} />
        </PieChart>
      </ResponsiveContainer>
    </div>
    <div className="space-y-2 mt-2">
      {sectors?.map((s, i) => (
        <div key={s?.name} className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ background: COLORS?.[i % COLORS?.length] }} />
            <span className="font-caption text-xs text-muted-foreground">{s?.name}</span>
          </div>
          <span className="font-data text-xs text-foreground font-medium">{s?.value?.toFixed(1)}%</span>
        </div>
      ))}
    </div>
  </div>
);

export default SectorAllocation;